import {CadesPlugin} from '../types/plugins/cadesPlugin';

export const loadCadesPlugin = async (): Promise<CadesPlugin | undefined> => {
    if (!window.cadesplugin) {
        await new Promise<void>((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'libs/cadesplugin_api.js';
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Не удалось загрузить cadesplugin_api.js'));
            document.body.appendChild(script);
        });
    }

    return window.cadesplugin;
};
